const DEFAULT_CURRENCY = "USD";

const formatCurrencyWithoutCents = (amount: number, currency: string) =>
  new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);

const normalizeAmount = (
  amount: number | string | null | undefined,
): number => {
  const parsedAmount =
    typeof amount === "string" ? Number(amount) : (amount ?? 0);
  return Number.isFinite(parsedAmount) ? parsedAmount : 0;
};

export const formatExperienceCredit = (
  amount: number | string | null | undefined,
  currency?: string | null,
) => {
  const normalizedAmount = normalizeAmount(amount);
  const normalizedCurrency = currency?.trim().toUpperCase() || DEFAULT_CURRENCY;

  let formattedValue = "";
  try {
    formattedValue = formatCurrencyWithoutCents(
      normalizedAmount,
      normalizedCurrency,
    );
  } catch {
    formattedValue = formatCurrencyWithoutCents(
      normalizedAmount,
      DEFAULT_CURRENCY,
    );
  }

  return `${formattedValue} Experience Credit`;
};
